<template>
    <div class="r flex">
        <!-- 选房间 -->
        <div class="r-c flex-item grow start" style="flex-basis: 0">
            <div class="r-title">1. 选择房间{{ title }}</div>
            <Tree
                :data="treeList"
                showCheckbox
                @on-check-change="onCheckHouse"
            />
        </div>
        <!-- 选字段 -->
        <div class="r-c flex-item start" style="width: 100px; margin: 0 20px">
            <div class="r-title">2. 选择字段</div>
            <check-tag-group v-model="enableFields" color="primary" multiple>
                <check-tag
                    v-for="item in roomFieldList"
                    style="width: 80%; display: block"
                    :name="item.id"
                    :key="item.id"
                    >{{ item.text }}</check-tag
                >
            </check-tag-group>
        </div>
        <!-- 编辑表单 -->
        <div
            class="r-c flex-item start"
            style="width: 540px; padding-right: 8px"
        >
            <div class="r-title">3. 编辑表单</div>
            <Form
                ref="info"
                :model="info"
                :label-width="100"
                :itemMarginBottom="10"
            >
                <FormItem
                    v-if="fieldsMap.rentType"
                    label="出租类型"
                    prop="rentType"
                >
                    <Select v-model="info.rentType" transfer>
                        <Option
                            v-for="item in this.dict.rentTypeNew.toList()"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.text }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem
                    v-if="fieldsMap.decorationType"
                    label="装修状态"
                    prop="decorationType"
                >
                    <Select
                        v-model="info.decorationType"
                        transfer
                        :placeholder="isView ? '' : '请选择装修状态'"
                    >
                        <Option
                            v-for="item in this.dict.decorationType.toList()"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.text }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem
                    v-if="fieldsMap.houseType"
                    label="装修格局"
                    prop="houseType"
                >
                    <Input v-model="info.houseType" placeholder />
                </FormItem>
                <FormItem
                    v-if="fieldsMap.orientation"
                    label="朝向"
                    prop="orientation"
                >
                    <Select v-model="info.orientation" transfer>
                        <Option
                            v-for="item in this.dict.orientation.toList()"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.text }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem
                    v-if="fieldsMap.rentMode"
                    label="交租方式"
                    prop="rentMode"
                >
                    <rent-mode
                        spread-out
                        :depositPayMethod="rentMode.depositPayMethod"
                        :rentPayMethod="rentMode.rentPayMethod"
                        @on-change="changeRentMode($event, info)"
                    />
                </FormItem>
                <FormItem
                    v-if="fieldsMap.otherDeposit"
                    prop="otherDeposit"
                    label="其它押金"
                >
                    <other-deposit :value="info.otherDeposit" />
                </FormItem>
                <FormItem
                    v-if="fieldsMap.otherFee"
                    prop="otherFee"
                    label="其它费用"
                >
                    <other-fee :value="info.otherFee" />
                </FormItem>
                <FormItem
                    v-if="fieldsMap.facilitys"
                    label="房间配置"
                    prop="facilitys"
                >
                    <room-config :value="info.facilitys" />
                </FormItem>
                <FormItem
                    v-if="fieldsMap.commission"
                    label="佣金"
                    prop="commission"
                >
                    <input-number v-model="info.commission" :min="0">
                    </input-number>
                </FormItem>
                <FormItem
                    v-if="fieldsMap.commissionRemark"
                    label="佣金说明"
                    prop="commissionRemark"
                >
                    <Input v-model="info.commissionRemark"></Input>
                </FormItem>
                <FormItem v-if="fieldsMap.tags" label="标签" prop="tags">
                    <Select v-model="info.tags" multiple transfer>
                        <Option
                            v-for="item in this.dict.houseTag.toList()"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.text }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem
                    v-if="fieldsMap.attachments"
                    label="图片"
                    prop="attachments"
                >
                    <preview-upload
                        v-model="info.attachments"
                        :maxSize="10 * 1024"
                        multiple
                    />
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
import { updateBatchNew, assetsHouseList } from '@/api/assets'
import mSelectHouse from '_v/common/m-select-house'
import RoomConfig from '_vc/fields/room-config'
import RentMode from '_vc/fields/rent-mode'
import OtherFee from '_vc/fields/other-fee'
import OtherDeposit from '_vc/fields/other-deposit'

// 房间可编译字段
var roomFieldList = [
    //
    { id: 'rentType', text: '出租类型' },
    { id: 'decorationType', text: '装修状态' },
    { id: 'houseType', text: '装修格局' },
    { id: 'orientation', text: '朝向' },
    { id: 'rentMode', text: '交租方式' },
    //
    { id: 'otherDeposit', text: '其它押金' },
    { id: 'otherFee', text: '其它费用' },
    //
    { id: 'facilitys', text: '房间配置' },
    { id: 'tags', text: '标签' },
    { id: 'commission', text: '佣金' },
    { id: 'commissionRemark', text: '佣金说明' },
    { id: 'attachments', text: '图片' },
]

export default {
    name: 'RoomBatchEditForm',
    mixins: [mSelectHouse],
    components: { RoomConfig, RentMode, OtherFee, OtherDeposit },
    props: {
        // 楼栋名称
        floorName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            // state
            filter: {
                parkId: this.parkId, // 园区/社区
                floorId: this.floorId, // 楼栋id
                floorNum: this.floorNum, // 楼层
                houseStatus: this.houseStatus, // 房间状态
                pageSize: 9999,
            },
            enableFields: [],
            title: '',
            // data
            treeList: [],
            info: {
                parkId: this.parkId, // 园区/社区
                floorName: this.floorName, //  楼栋
                floorId: this.floorId, // 楼栋id
                floorNum: '', // 楼层
                houseNum: '', //房间号
                houseNo: '', //  房间代码
                rentType: '', // 出租类型
                buildArea: '', // 建筑面积
                buildArea: '', // 建筑面积
                decorationType: '', // 装修状态
                houseType: '', // 装修格局
                orientation: '', // 朝向
                //
                unitPrice: '', // 单价
                minPrice: '', //(最低单价(分))
                maxPrice: '', //(最高单价(分))
                rent: '', // 租金
                depositPayMethod: '', // 交租方式_押金
                rentPayMethod: '', // 交租方式
                deposit: '', // 常规押金
                otherFee: [], // 其它费用
                otherDeposit: [], // 其它押金
                //
                facilitys: [], // 房间配置
                tags: [], // 标签
                wifiPwd: '', // wifi密码
                commission: '', // 佣金
                commissionRemark: '', // 佣金说明
                attachments: '', // 图片
                remark: '', //备注
            },
            rentMode: {
                depositPayMethod: '',
                rentPayMethod: '',
            },
            dict: {
                parkType: this.$dict.NULL,
                decorationType: this.$dict.NULL,
                rentTypeNew: this.$dict.NULL,
                orientation: this.$dict.NULL,
                houseTag: this.$dict.NULL,
            },
            roomFieldList,
            fieldsMap: {},
        }
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    watch: {
        enableFields(val) {
            this.fieldsMap = val.reduce((acc, v) => {
                acc[v] = true

                return acc
            }, {})
        },
    },
    mounted() {
        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.$dict.get([
                    'park_type',
                    'decoration_type',
                    'rent_type_new',
                    'orientation',
                    'house_tag',
                ]),
                assetsHouseList(this.filter),
            ])
                .then((args) => {
                    var [group, view] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = group[name]
                    })

                    this.treeList = this.normalizeHouseList(
                        view?.data?.page?.list
                    )
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            return Promise.resolve()
                .then(() => {
                    if (this.selectedHouse.length <= 0) {
                        return Promise.reject({
                            msg: '请选择房间',
                        })
                    }
                })
                .then(() => {
                    if (this.enableFields.length <= 0) {
                        return Promise.reject({
                            msg: '请选择字段',
                        })
                    }
                })
                .then(() => {
                    var formData = {
                            ids: this.selectedHouse.map((v) => v.id).join(','),
                        },
                        data = this.$refs.info.populateData()

                    this.enableFields.forEach((k) => {
                        switch (k) {
                            // 交租方式
                            case 'rentMode':
                                formData.depositPayMethod =
                                    data.depositPayMethod
                                formData.rentPayMethod = data.rentPayMethod
                                formData.deposit = data.deposit
                                break
                            default:
                                formData[k] = data[k]
                        }
                    })

                    return updateBatchNew(formData)
                })
                .then(() => {
                    this.$Message.success({
                        content: '修改成功',
                    })
                    this.$emit('search')
                    this.$modal.onClose()
                })
                .catch((err) => {
                    if (err && err.msg) {
                        this.$Message.error({
                            content: err.msg,
                        })
                    }
                    options.closeModal = false
                })
                .finally(() => next())
        })
    },
    methods: {
        // 交租方式更改
        changeRentMode(val) {
            this.info.depositPayMethod = val.depositPayMethod
            this.info.rentPayMethod = val.rentPayMethod
            this.info.deposit = val.depositPayMethod * this.info.rent
        },
    },
}
</script>

<style lang="less" scoped>
.r {
    height: 100%;

    &-title {
        font-size: 16px;
        margin-bottom: 10px;
    }

    &-c {
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
</style>
